<div class="px-3" >
    <ng-container *ngFor="let p of plugins">
        <div class="row border border-primary mb-2" >
            <div class="col-lg-2 alert-primary py-2">
                <h4>{{p.name}}</h4>
                <small>{{p.version}}</small><br/>
                <br/>
                <small>{{p.description}}</small>
            </div>            
            <div class="col-lg-10">
                <table class="table table-sm">
                    <tr *ngFor="let setting of p.settings">
                        <td>
                            <ng-container *ngIf="setting.type!='function'">
                                <label>{{setting.label}}</label>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container [ngSwitch]="setting.type">
                                <ng-container *ngSwitchCase="'password'">
                                    <input type="password" class="form-control form-control-sm" [(ngModel)]="setting.value">
                                </ng-container>
                                <ng-container *ngSwitchCase="'number'">
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="setting.value">
                                </ng-container>
                                <ng-container *ngSwitchCase="'boolean'">
                                    <select class="form-control form-control-sm" [(ngModel)]="setting.value">
                                        <option  [ngValue]="true">Si</option>
                                        <option  [ngValue]="false">No</option>
                                    </select>
                                </ng-container>
                                <ng-container *ngSwitchCase="'select'">
                                    <select class="form-control form-control-sm" [(ngModel)]="setting.value">
                                        <option *ngFor="let option of setting.options" [ngValue]="option">{{option}}</option>
                                    </select>
                                </ng-container>
                                <ng-container *ngSwitchCase="'function'">
                                    <button class="btn btn-sm btn-block btn-outline-primary" (click)="runFunction(p.name,setting.name,p)">{{setting.label}}</button>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <input type="text" class="form-control form-control-sm" [(ngModel)]="setting.value">
                                </ng-container>
                            </ng-container>
                        </td>
                        <td>
                            <small class="text-gray">{{setting.description}}</small>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </ng-container>
</div>